// extracted by mini-css-extract-plugin
export default {"content":"Modal_content__SKyXI","visible":"Modal_visible__uNtmT"};